export const ELEMENT_CODE_HIGHLIGHT_BLOCK = 'code_highlight_block';
